import { render } from "./BackupEdit.vue?vue&type=template&id=eb909d42"
import script from "./BackupEdit.vue?vue&type=script&lang=js"
export * from "./BackupEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__